import * as React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import { FormattedMessage, useIntl } from "react-intl";
import NewsletterForm from "./newsletter-form";
import Link from "./link";

const renderOptions = {
  renderNode: {
    [BLOCKS.HEADING_2]: (_node, children) => (
      <h2 className="heading">{children}</h2>
    ),

    [BLOCKS.PARAGRAPH]: (node, children) => {
      const [{ value }] = node.content;

      if (value !== "" || node.content.length > 1) {
        return <p>{children}</p>;
      }

      return null;
    },

    [BLOCKS.EMBEDDED_ASSET]: (node) => {
      const image = node.data.target;

      if (image) {
        return <GatsbyImage image={image.gatsbyImageData} alt={image.title} />;
      }

      return null;
    },

    [INLINES.HYPERLINK]: (node, children) => (
      <Link href={node.data.uri}>{children}</Link>
    ),
  },
};

const Presentation = ({ destination, product, title }) => {
  const { presentation } = destination || product;
  const { formatMessage } = useIntl();

  if (presentation) {
    return (
      <section
        className={`presentation${product ? ` presentation-product` : ""}`}
        aria-labelledby={destination ? "presentation-heading" : null}
      >
        <div
          className="container"
          data-has-one-child={destination?.hideBadge && !product}
        >
          <div className="presentation-content">
            {destination && (
              <h1 id="presentation-heading" className="heading">
                {title ? title : <FormattedMessage id="presentation" />}
              </h1>
            )}
            {presentation && renderRichText(presentation, renderOptions)}
            {destination?.hideProducts && (
              <div className="presentation-newsletter">
                <span
                  dangerouslySetInnerHTML={{
                    __html: formatMessage({
                      id: "productsNewsletter",
                    }),
                  }}
                />
                <NewsletterForm destination={destination} listId={79} />
              </div>
            )}
          </div>
          <div className="presentation-sidebar">
            {destination?.badge && !destination?.hideBadge && (
              <img
                src={destination.badge.file.url}
                alt={destination.badge.title}
                width={destination.badge.file.details.image.width}
                height={destination.badge.file.details.image.height}
                loading="lazy"
                decoding="async"
              />
            )}
            {product && (
              <dl className="figures">
                <div>
                  <dt>
                    <FormattedMessage id="metaDateRange" />
                  </dt>
                  <dd>{product.destination.dateRange}</dd>
                </div>
                <div>
                  <dt>
                    <FormattedMessage id="metaDuration" />
                  </dt>
                  <dd>{product.duration}</dd>
                </div>
                <div>
                  <dt>
                    <FormattedMessage id="metaDistance" />
                  </dt>
                  <dd>{product.distance}</dd>
                </div>
                <div>
                  <dt>
                    <FormattedMessage id="metaElevation" />
                  </dt>
                  <dd>{product.elevation}</dd>
                </div>
                <div>
                  <dt>
                    <FormattedMessage id="metaDifficulty" />
                  </dt>
                  <dd>{product.difficulty} / 5</dd>
                </div>
              </dl>
            )}
          </div>
        </div>
      </section>
    );
  }

  return null;
};

export default Presentation;
